'use strict'

module.exports = require('./dist/react-tooltip')



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tooltip/index.js
 ** module id = 152
 ** module chunks = 0
 **/